module.exports = __webpack_public_path__ + "img/herausforderung_1024.b1077890.svg";